document.addEventListener("DOMContentLoaded", function() {
  const patchStorefrontAccessibility = () => {
    // 1. JUNIP FILTER ARIA LABELS
    const filterToggle = document.querySelector('.junip-label-container');
    if (filterToggle) {
      if (filterToggle.getAttribute('aria-label') !== 'Sort & Filter') {
        filterToggle.setAttribute('aria-label', 'Sort & Filter');
      }

      const parentFilterSection = filterToggle.closest('.junip-filters');
      if (parentFilterSection) {
        const filterPanel = parentFilterSection.querySelector('.junip-filters-container') || parentFilterSection.querySelector('div:nth-child(2)');
        if (filterPanel && filterPanel.id !== 'junip-filters-container') {
          filterPanel.setAttribute('id', 'junip-filters-container');
        }
      }
    }

    // 2. JUNIP: FIX VISIBLE LABEL VS ACCESSIBLE NAME MISMATCHES
    const mediaCheckbox = document.querySelector('.junip-checkbox');
    if (mediaCheckbox && mediaCheckbox.getAttribute('aria-label') !== 'With media') {
      mediaCheckbox.setAttribute('aria-label', 'With media');
    }

    // 3. JUNIP: FIX ACCESSIBLE ROLES FOR INTERACTIVE IMAGE LIGHTBOXES
    const imageWrappers = document.querySelectorAll('.junip-review-image-wrapper[tabindex="0"]:not([role])');
    imageWrappers.forEach(wrapper => {
      wrapper.setAttribute('role', 'button');
    });

    // 4. REPLO: FIX CUSTOM LISTBOX/SWATCH ACCESSIBLE NAMES
    document.querySelectorAll('[data-replo-option-select="true"][role="listbox"]').forEach(el => {
      if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) {
        const siblingText = el.previousElementSibling;
        let labelText = "Product options";
        
        if (siblingText && siblingText.textContent.trim()) {
          labelText = "Select " + siblingText.textContent.trim();
        } else {
          const parentBlock = el.closest('[data-replo-component-root]');
          if (parentBlock) {
            const fallbackHeading = parentBlock.querySelector('p, span, h2, h3, h4');
            if (fallbackHeading && fallbackHeading.textContent.trim().length < 30) {
              labelText = "Select " + fallbackHeading.textContent.trim();
            }
          }
        }
        el.setAttribute('aria-label', labelText);
      }
    });

    // 5. REPLO: RESOLVE NESTED INTERACTIVE ELEMENTS (BUTTON IN BUTTON)
    const nestedWrappers = document.querySelectorAll('[data-replo-add-product-variant-to-cart][role="button"]');
    nestedWrappers.forEach(wrapper => {
      if (wrapper.querySelector('button, a, input, [tabindex="0"]')) {
        wrapper.removeAttribute('role');
        wrapper.removeAttribute('tabindex');
      }
    });

    // 6. SITEWIDE: RESOLVE HEADING LEVEL HIERARCHY JUMPS
    const relatedHeading = document.querySelector('span > h3');
    if (relatedHeading && relatedHeading.textContent.trim() === 'Related Products') {
      const h2 = document.createElement('h2');
      h2.innerHTML = relatedHeading.innerHTML;
      if (relatedHeading.className) h2.className = relatedHeading.className;
      if (relatedHeading.getAttribute('style')) h2.setAttribute('style', relatedHeading.getAttribute('style'));
      if (relatedHeading.getAttribute('data-rid')) h2.setAttribute('data-rid', relatedHeading.getAttribute('data-rid'));
      
      relatedHeading.parentNode.replaceChild(h2, relatedHeading);
    }

    // =========================================================================
    // 7. DYNAMIC FIX: RESOLVE DUPLICATE PRODUCT FORM IDs (Moved Inside Observer)
    // =========================================================================
    const globalForms = document.querySelectorAll('form[data-productid]');
    const globalTracker = {};

    globalForms.forEach((form) => {
      const pId = form.getAttribute('data-productid');
      const baseIdString = `product-form-${pId}`;

      if (!globalTracker[pId]) {
        globalTracker[pId] = 0;
      }

      globalTracker[pId]++;
      
      // Strict index token (e.g., product-form-8077112082652-1)
      const definitiveUniqueId = `${baseIdString}-${globalTracker[pId]}`;

      if (form.getAttribute('id') !== definitiveUniqueId) {
        form.setAttribute('id', definitiveUniqueId);

        // Re-link internal buttons/variants sitting inside this form
        form.querySelectorAll('[form]').forEach((childElement) => {
          childElement.setAttribute('form', definitiveUniqueId);
        });

        // Re-link external checkout or buy buttons sitting outside the form scope
        const structuralContainer = form.closest('[data-replo-product-container], .product-form, product-form');
        if (structuralContainer) {
          structuralContainer.querySelectorAll(`[form="${baseIdString}"], [form="${baseIdString.replace(/\\/g, '')}"]`).forEach((externalBtn) => {
            externalBtn.setAttribute('form', definitiveUniqueId);
          });
        }
      }
    });
  };

  // Run initial pass immediately
  patchStorefrontAccessibility();

  // Watch the document body continuously to catch Replo/Shopify dynamic hydration
  const globalObserver = new MutationObserver(patchStorefrontAccessibility);
  globalObserver.observe(document.body, { childList: true, subtree: true });

const klaviyoForms = document.querySelectorAll('form[data-testid^="klaviyo-form-"]');

klaviyoForms.forEach(form => {
  // 1. Ensure the form clearly signals its purpose so context changes are anticipated
  if (!form.hasAttribute('aria-label') && !form.hasAttribute('aria-labelledby')) {
    form.setAttribute('aria-label', 'Newsletter Sign Up Form');
  }

  // 2. Target interactive inputs inside Klaviyo that might cause auto-submission or tab jumps
  const formInputs = form.querySelectorAll('input[type="checkbox"], input[type="radio"], select, input[type="email"]');
  
  formInputs.forEach(input => {
    // If an input lacks an explicit warning, append an aria-description to alert screen readers
    if (!input.hasAttribute('aria-description')) {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.setAttribute('aria-description', 'Selecting this option may update the form state immediately.');
      } else if (input.type === 'email') {
        input.setAttribute('aria-description', 'Pressing Enter will submit the form.');
      }
    }
  });
});
const dynamicKlaviyoForm = document.querySelector('form[data-testid="klaviyo-form-TX99Rb"]');

if (dynamicKlaviyoForm) {
  // 1. Label the form block so screen readers know it's a promotion overlay
  if (!dynamicKlaviyoForm.hasAttribute('aria-label')) {
    dynamicKlaviyoForm.setAttribute('aria-label', 'Welcome Discount Sign Up Form');
  }

  // 2. Fix the Email Input "On Input / Context Change" warnings
  const emailField = dynamicKlaviyoForm.querySelector('input[type="email"]');
  if (emailField && !emailField.hasAttribute('aria-description')) {
    emailField.setAttribute('aria-description', 'Pressing Enter or clicking continue will submit the form and close the window.');
  }

  // 3. Fix the "Strong tag should be tagged properly" error on the main heading text
  const promoHeadingSpan = dynamicKlaviyoForm.querySelector('span.ql-font-pragmatica-extended[style*="font-weight:bold"]');
  if (promoHeadingSpan && !promoHeadingSpan.hasAttribute('role')) {
    promoHeadingSpan.setAttribute('role', 'strong');
  }

  // 4. Fix the descriptive imagery missing alternative text tags
  const layoutImage = dynamicKlaviyoForm.querySelector('img[src*="cloudfront.net/company/Yc6iJH"]');
  if (layoutImage && (!layoutImage.getAttribute('alt') || layoutImage.getAttribute('alt') === '')) {
    layoutImage.setAttribute('alt', 'Promotional offer background lifestyle image');
  }
}
(function () {
    function cleanReploTabs() {
      // 1. Target the main tablist container wrapper
      const tablist = document.querySelector('[role="tablist"]');
      if (tablist) {
        // Strip the focus trap from the container element itself
        if (tablist.hasAttribute('tabindex')) {
          tablist.removeAttribute('tabindex');
        }
      }

      // 2. Target the buttons to fix manual keyboard tab configurations
      const buttons = document.querySelectorAll('button[role="tab"]');
      buttons.forEach(button => {
        // Enforce proper keyboard navigation for inactive tabs
        if (button.getAttribute('aria-selected') === 'false' && button.getAttribute('tabindex') !== '-1') {
          button.setAttribute('tabindex', '-1');
        } 
        // Enforce proper keyboard navigation for the active tab
        else if (button.getAttribute('aria-selected') === 'true' && button.getAttribute('tabindex') !== '0') {
          button.setAttribute('tabindex', '0');
        }
      });

      // 3. Clean all illegal attributes from the 6 internal layout divs
      const internalDivs = document.querySelectorAll('button[role="tab"] div[tabindex="0"]');
      internalDivs.forEach(div => {
        div.removeAttribute('tabindex');
        div.removeAttribute('role');
        div.removeAttribute('aria-checked');
      });
    }

    // Run immediately when the DOM is parsing
    cleanReploTabs();

    // Run again once everything is fully loaded
    window.addEventListener('DOMContentLoaded', cleanReploTabs);

    // Actively watch for Replo framework changes to stop them from reappearing
    const observer = new MutationObserver(() => {
      cleanReploTabs();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
});